// Campus photo for /colleges/university-of-mississippi: CC BY-SA 4.0, by Fredlyfish4, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AThe_Lyceum_University_of_Mississippi_2018_2.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-mississippi/; credited under the photo.
const photo = {
    "slug": "university-of-mississippi",
    "alt": "The Lyceum seen from the Circle at the University of Mississippi in Oxford, Mississippi",
    "src": "/colleges/university-of-mississippi/campus-1600.webp",
    "srcSmall": "/colleges/university-of-mississippi/campus-800.webp",
    "srcMid": "/colleges/university-of-mississippi/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-mississippi/og.jpg",
    "title": "The Lyceum University of Mississippi 2018 2",
    "author": "Fredlyfish4",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AThe_Lyceum_University_of_Mississippi_2018_2.jpg",
    "read": "2026-10-01"
};

export default photo;
